import React, {  useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest, emptyAction} from '../redux/actions/CommonActions'
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
const TimeSheetContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const params = useParams();
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token){
        dispatch(emptyAction("SET_TIMESHEET"));
        dispatch(getDataOnRequest(props.userAuth.users_access_token,'GetTimeSheet','SET_TIMESHEET',params.id))
      }
   }, [dispatch, props.userAuth.users_access_token, params.id]);

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData,
    timesheet:state.timesheet.timesheet
  };
};

const composedTimeSheetContainer = compose(connect(mapStateToProps), TimeSheetContainer)
export default composedTimeSheetContainer;

